import { environment } from 'src/environments/environment';

/**
 * Console logging that does not ship to production.
 *
 * The contribution path logs freely while it is being worked on — wallet addresses, USDT balances,
 * gas estimates, transaction hashes, receipts, the whole user-details response. Angular's production
 * build does **not** strip `console.*`, so all of it reached the devtools console of every
 * contributor (troubleshooting.md Q4). Deleting the logs would have taken away the only visibility
 * anyone has into a failing contract write, so they are gated instead.
 *
 * `environment.production` is `true` only in `environment.production.ts`, so these still print on
 * development, pre-development and staging — the environments where someone is actually debugging.
 *
 * Use it for anything that echoes a value. Genuine failures stay on `console.error`, which is the
 * app's error reporting and is meant to reach production.
 */
export function devLog(...args: unknown[]): void {
  if (!environment.production) {
    console.log(...args);
  }
}

/** The `console.warn` counterpart of {@link devLog}. */
export function devWarn(...args: unknown[]): void {
  if (!environment.production) {
    console.warn(...args);
  }
}
